import $ from 'jquery';

// Collapse prevent close data attribute
// Author: Wakefly
// Purpose: To prevent Bootstrap collapse toggles from closing (collapsing) its collapse target on click, apply this data attribute.
$(function() {
  // When collapse toggle element with [data-collapse-toggle-prevent-close="true"] is clicked
  // and the collapse target is already open, then don't close the collapse target
  $('[data-collapse-toggle-prevent-close="true"]').each(function() {
    let $toggleElement = $(this);
    let $collapseElement = $($toggleElement.data('target') || $toggleElement.attr('href'));

    $toggleElement.click(function(e) {
      if ($collapseElement.hasClass('show')) {
        e.stopPropagation();
      }
    });
  });
});